import React from "react";
import { FaMicrophoneSlash, FaVideoSlash } from "react-icons/fa";
import usePointerDrag from "./usePointerDrag";
import { StreamVideo } from "./StreamMedia";
import "./meeting.css";

export default function DraggableStream({
  stream,
  userName,
  isMuted,
  isCameraOn,
  boundsRef,
}) {
  const drag = usePointerDrag({ boundsRef });
  return (
    <div
      ref={drag.ref}
      {...drag.handlers}
      className="ant-call-mini"
      style={drag.style}
    >
      {isCameraOn && stream ? (
        <StreamVideo stream={stream} />
      ) : (
        <div className="ant-call-camera-off">
          <FaVideoSlash />
          <span>Camera off</span>
        </div>
      )}
      {isMuted && (
        <span className="ant-call-mic-badge">
          <FaMicrophoneSlash />
        </span>
      )}
      <span className="ant-call-name">{userName}</span>
    </div>
  );
}
